module.exports = __webpack_public_path__ + "static/media/donggubat_factory.ai.1b8f5773.zip";